import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogout = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.88876 3.85221V1.77814C8.88876 1.62097 8.82633 1.47025 8.7152 1.35911C8.60406 1.24798 8.45334 1.18555 8.29617 1.18555H1.77765C1.62049 1.18555 1.46976 1.24798 1.35862 1.35911C1.24749 1.47025 1.18506 1.62097 1.18506 1.77814V14.2226C1.18506 14.3797 1.24749 14.5305 1.35862 14.6416C1.46976 14.7527 1.62049 14.8152 1.77765 14.8152H8.29617C8.45334 14.8152 8.60406 14.7527 8.7152 14.6416C8.82633 14.5305 8.88876 14.3797 8.88876 14.2226V12.1485",
			stroke: "#002E5F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8149 8H5.33346",
			stroke: "#002E5F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.852 5.03711L14.8149 8.00007L11.852 10.963",
			stroke: "#002E5F",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgLogout);
export default ForwardRef;
